import React from 'react';
import aboutUsImage from '../img/envision/aerospace/tabsimages/bfsidataprotaction.jpg'; // Import the image

const AboutUs = () => {
  return (
    <section className="about-area ptb-100">
      <div className="container">
        <div className="row align-items-center">
          {/* About Content */}
          <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
            <div className="container" style={{ textAlign: 'center' }}>
              <div className="row" style={{ paddingBottom: '20px' }}>
                <div className="container">
                  <h1
                    style={{
                      color: "#000",
                      fontSize: '48px',
                      display: 'inline-block',
                      position: 'relative',
                      fontFamily: 'lato, sans-serif',
                    }}
                  >
                    About <span style={{ color: "#f7941d" }}>Us</span>
                    <span
                      style={{
                        position: 'absolute',
                        bottom: '-8px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '50%',
                        height: '2px',
                        backgroundColor: '#000',
                      }}
                    />
                  </h1>
                </div>
              </div>
              <h2
                style={{
                  color: 'rgb(16, 16, 14)',
                  fontSize: '20px',
                  fontWeight: '700',
                  fontFamily: 'lato, sans-serif',
                }}
              >
                Empowering Minds Through Knowledge and Innovation.
              </h2>
              <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                Welcome to <span style={{ fontFamily: 'urbanist , sarif', color: 'black' }}>IIA Learning Institute</span>, where education meets innovation. We are committed to delivering world-class learning solutions that inspire, engage, and prepare individuals for success in an evolving world.
              </p>
              <p style={{ fontSize: '16px', textAlign: 'justify' }}>
                At <span style={{ fontFamily: 'urbanist , sarif', color: 'black' }}>IIA</span>, we believe in fostering an environment where learning is accessible, collaborative, and impactful for our Aspirants. Our expert educators and cutting-edge tools provide an immersive learning experience tailored to every student’s unique needs.
              </p>
            </div>
          </div>

          {/* About Image */}
          <div className="col-lg-6 col-md-12">
            <div className="about-text text-center">
              <img src={aboutUsImage} alt="About Us" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
